import React from 'react';
import { LegacyCtaSocial } from './LegacyCtaSocial';
import { LegacyCtaFullWidth } from './LegacyCtaFullWidth';
import { LegacyCtaCandy } from './LegacyCtaCandy';
import { LegacyCtaBean } from './LegacyCtaBean';
import { LegacyCtaImage } from './LegacyCtaImage';
import { CtasListItem } from '../data-transformations/create-cta-data';

export interface CtaProps {
    readonly configuration: Partial<CtasListItem>;
    readonly disclaimerHref: string;
    readonly onSubmitFormInputValue: (inputValue: string) => void;
    readonly onConvertClick: () => void;
    readonly isDemoMobileScreen?: boolean;
}

export const LegacyCta: React.FC<CtaProps> = ({
    configuration,
    disclaimerHref,
    isDemoMobileScreen,
    onConvertClick,
    onSubmitFormInputValue
}) => {
    return configuration.type === 'button' ||
        configuration.type === 'text-link' ||
        configuration.type === 'form' ? (
        configuration.theme === 'social' ? (
            <LegacyCtaSocial
                configuration={configuration}
                disclaimerHref={disclaimerHref}
                isDemoMobileScreen={isDemoMobileScreen}
                onConvertClick={onConvertClick}
                onSubmitFormInputValue={onSubmitFormInputValue}
            />
        ) : configuration.theme === 'candy' ? (
            <LegacyCtaCandy
                configuration={configuration}
                disclaimerHref={disclaimerHref}
                isDemoMobileScreen={isDemoMobileScreen}
                onConvertClick={onConvertClick}
                onSubmitFormInputValue={onSubmitFormInputValue}
            />
        ) : configuration.theme === 'bean' ? (
            <LegacyCtaBean
                configuration={configuration}
                disclaimerHref={disclaimerHref}
                isDemoMobileScreen={isDemoMobileScreen}
                onConvertClick={onConvertClick}
                onSubmitFormInputValue={onSubmitFormInputValue}
            />
        ) : configuration.theme === 'fullwidth' ? (
            <LegacyCtaFullWidth
                configuration={configuration}
                disclaimerHref={disclaimerHref}
                isDemoMobileScreen={isDemoMobileScreen}
                onConvertClick={onConvertClick}
                onSubmitFormInputValue={onSubmitFormInputValue}
            />
        ) : null
    ) : configuration.type === 'image-ad' ? (
        <LegacyCtaImage
            configuration={configuration}
            disclaimerHref={disclaimerHref}
            isDemoMobileScreen={isDemoMobileScreen}
            onConvertClick={onConvertClick}
            onSubmitFormInputValue={onSubmitFormInputValue}
        />
    ) : null;
};
